import { HTMLRefType } from 'components/shared/sharedTypes/form.types'

export const executeScroll = (topFormRefTyped: HTMLRefType): void => {
  if (topFormRefTyped?.current?.scrollIntoView) topFormRefTyped.current.scrollIntoView()
}
